import React from 'react'

import { client } from 'config/routes'

import { DropdownHeader } from './DropdownHeader'

export const HowItWorksDropdown = () => (
  <DropdownHeader
    titleText="how it works"
    links={[
      { href: client.howGoustoWorks, text: 'How Gousto Works' },
      { href: client.goustoMealPlanning, text: 'Menus and Meal Planning' },
      { href: client.ourSuppliers, text: 'Our Suppliers' },
      { href: client.weCare, text: 'Sustainability' },
    ]}
  />
)
